import {useEffect} from 'react';

const useSetTabTitle = (title: string, deps?: any) => {
  useEffect(() => {
    document.title = title;
  }, [deps]);
};

export default useSetTabTitle;
